import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { FormikTabButtonGroup } from 'src/Libs/inputs/formik/index'
import { useField, useFormikContext } from 'formik'
import { isUndefined } from 'lodash'

export interface Props {
  trueLabel: string
  falseLabel: string
  name: string
  onChange?: (index: number) => void
  disabled?: boolean
  fullWidth?: boolean
}

const BooleanToggle: React.FC<Props> = ({ trueLabel, falseLabel, name, disabled = false, fullWidth = false }) => {
  const expectedFieldValues = useMemo(
    () => [
      { label: trueLabel, value: true },
      { label: falseLabel, value: false },
    ],
    [trueLabel, falseLabel]
  )

  const [field] = useField(name)
  const { setFieldValue } = useFormikContext()
  const [currentActive, setCurrentActive] = useState<number>(expectedFieldValues.findIndex(item => item.value === field.value, 0))

  const onOffActions = expectedFieldValues.map((values, index) => ({ id: `${name}-${index}`, label: values.label }))

  useEffect(() => {
    if (isUndefined(field.value)) {
      return
    }
    const nextIndex = expectedFieldValues.findIndex(item => item.value === field.value, 0)

    if (nextIndex !== currentActive) {
      setCurrentActive(nextIndex)
    }
  }, [field.value, currentActive, expectedFieldValues])

  const handleChange = useCallback(
    (activeIndex: number) => {
      setCurrentActive(activeIndex)

      const fieldValue = expectedFieldValues.find((_, index) => index === activeIndex, null)?.value || false

      setFieldValue(name, fieldValue)
    },
    [name, expectedFieldValues, setFieldValue]
  )

  return <FormikTabButtonGroup active={currentActive} onChange={handleChange} actions={onOffActions} disabled={disabled} fullWidth={fullWidth} />
}

export default BooleanToggle
